import styled from 'styled-components'

export const Wrapper = styled.div<{ $width: number; $height: number }>`
  width: ${({ $width }) => $width}px;
  height: ${({ $height }) => $height}px;
  border-radius: 4px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  cursor: grabbing;
`

export const MediaImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
`
